export default __webpack_public_path__ + "static/media/IMG_5002-min.163bd4a3.JPG";